module.exports = __webpack_public_path__ + "img/vaskovino-1-320x100.80d9b219.png";